<template>
  <div id="view-container">
    <p
      v-if="mapInformation.point"
      class="title text-center"
    >
      Where do you live, work/go to school, meet, and play
      (shopping/recreation/entertainment)? <br>
      Click and place icons into the map below
    </p>
    <CommentTypeSelect
      class="text-center"
    />
    <p
      class="title text-center"
    >
      Home |&nbsp; Work |&nbsp; Meet |&nbsp; Play
    </p>
    <div
      id="view"
      ref="map"
      class="map"
    />

    <!-- <div
      id="legend"
      class="esri-widget"
    >
      //If we need legend again, its here
      <MultiPointMapLegend />
    </div> -->

    <div
      id="remove-points"
      class="esri-widget"
    >
      <button
        id="reset"
        type="button"
      >
        Remove all points
      </button>
    </div>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import { mapState, mapActions } from "vuex";
import CommentTypeSelect from "@/components/Survey/CommentTypeSelect";

export default {
  name: "MultiPointMap",
  components: {
    CommentTypeSelect,
  },
  props: {
    mapInformation: {
      type: Object,
      default: () => {
        return {
          coordinates: [-84.3880, 33.7490],
          zoom: 10,
          point: true // Will most likely not be used
        }
      }
    },
  },
  data() {
    return {
      baseUrl: "https://static.arcgis.com/images/Symbols/PeoplePlaces/",
      urls: {
        home: () => {
          return this.baseUrl + "Housing.png";
        },
        work: () => {
          return this.baseUrl + "Office.png";
        },
        meet: () => {
          return this.baseUrl + "Crowd.png";
        },
        play: () => {
          return this.baseUrl + "Sports.png";
        }
      },

      baseMarker: {
        type: "picture-marker",
        url: "",
        width: 30,
        height: 30
      }
    };
  },
  computed: {
    ...mapState({
      commentType: state => state.response.commentType,
      coordinatesWithType: state => state.response.coordinatesWithType
    })
  },
  mounted() {
    /* eslint-disable */
    const options = { version: "4.12", css: true }; // explicitly set API version to avoid future breaking changes
    loadModules(["esri/Map", "esri/Graphic", "esri/widgets/Locate", "esri/views/MapView", "esri/widgets/Home"], options)
    .then(([Map, Graphic, Locate, MapView, Home]) => {
      const map = new Map({
        basemap: "streets-vector"
      });
      const view = new MapView({
        map: map,
        container: "view",
        center: this.mapInformation.coordinates,
        zoom: this.mapInformation.zoom,
        ui: {
          components: ["attribution"]
        }
      });
      const button = new Home({
        view: view
      });
      const locate = new Locate({
        view: view
      });
      view.ui.add(button, "bottom-left");
      view.ui.add(locate, "bottom-left");
      view.ui.add("remove-points", "bottom-trailing");
      // view.ui.add("legend", "top-left");

      const reset = () => {
        view.graphics.removeAll();
        this.setResponseCoordinatesWithType([]);
      };

      document.getElementById("reset").onclick = reset;

      view.on("click", event => {
        const coords = view.toMap({ x: event.x, y: event.y });
        const type = this.commentType;

        const point = {
          type: "point",
          longitude: coords.longitude,
          latitude: coords.latitude
        };

        let pointGraphic = new Graphic({
          geometry: point
        });

        if (type) {
          const graphicToRemove = view.graphics._items.find(
            item => item.type == type
          );
          view.graphics.remove(graphicToRemove);

          const url = this.urls[type]();
          let markerSymbol = this.getMarkerSymbol(url);
          pointGraphic.symbol = markerSymbol;
          pointGraphic.type = type;
          view.graphics.add(pointGraphic);
        }

        const coordsWithType = view.graphics._items.map(item => ({
          type: item.type,
          x: item.geometry.x,
          y: item.geometry.y
        }));

        this.setResponseCoordinatesWithType(coordsWithType);
      });
    })
    .catch(err => {
      console.error(err);
    });
  },
  methods: {
    ...mapActions({
      setResponseCoordinatesWithType: "response/setResponseCoordinatesWithType",
    }),
    getMarkerSymbol(url) {
      return { ...this.baseMarker, url: url };
    }
  }
};
</script>

<style>
.map {
  height: 400px;
}
</style>